import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { splitObject, splitField, OPERATOR, LOGICAL, splitList } from './request';
import dataItem from './dataItem';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { customerResource } from '@/views/system/customerManage/request';
export default {
  components: {
    dataItem
  },
  data() {
    return {
      OPERATOR,
      LOGICAL,
      splitObjectList: [],
      splitFieldList: [],
      customerList: [],
      condition: [{
        field: undefined,
        operator: undefined,
        value: '',
        logical: undefined,
        group: []
      }],
      conditionObj: {
        field: undefined,
        operator: undefined,
        value: '',
        logical: undefined,
        group: []
      },
      form: {
        objectId: undefined,
        customerId: undefined,
        condition: []
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [],
      tableData: []
    };
  },
  created() {
    this.getsplitObjectFun();
  },
  methods: {
    async getsplitObjectFun() {
      this.splitObjectList = await splitObject({});
      this.customerList = await customerResource({});
    },
    async objectChangeFun() {
      this.condition = [recursionCopy(this.conditionObj)];
      this.columns = [];
      this.tableData = [];
      this.pagination.current = 0;
      this.pagination.total = 0;
      if (!this.form.objectId) {
        return false;
      }
      this.splitFieldList = await splitField({
        objectId: this.form.objectId,
        customerId: this.form.customerId
      });
    },
    customerChangeFun() {
      if (this.form.objectId) {
        this.objectChangeFun();
      }
    },
    addGroundFun(leve, index, index2, index3) {
      console.log(this.condition[Number(leve - 1)]);
      if (leve == 1) {
        this.condition[index].group.push(recursionCopy(this.conditionObj));
      } else if (leve == 2) {
        this.condition[index].group[index2].group.push(recursionCopy(this.conditionObj));
      }
    },
    addLeveFun(leve, index, index2) {
      if (leve == 1) {
        this.condition.push(recursionCopy(this.conditionObj));
      } else if (leve == 2) {
        this.condition[index].group.push(recursionCopy(this.conditionObj));
      } else {
        console.log(this.condition[index].group[index2]);
        this.condition[index].group[index2].group.push(recursionCopy(this.conditionObj));
      }
    },
    delItemFun(leve, index, index2, index3) {
      if (leve == 1) {
        this.condition.splice(index, 1);
      } else if (leve == 2) {
        this.condition[index].group.splice(index2, 1);
      } else {
        this.condition[index].group[index2].group.splice(index3, 1);
      }
    },
    onSearch() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    async getDataFun() {
      const h = this.$createElement;
      console.log(this.condition);
      const arr = recursionCopy(this.condition);
      let new_arr = [];
      arr.map(item => {
        let obj = {};
        if (item.field && item.operator && item.value && item.logical) {
          obj = {
            field: item.field,
            operator: item.operator,
            value: item.value,
            logical: item.logical
          };
          new_arr.push(obj);
        }
        // if (item.group.length != 0) {
        //   obj = {
        //     logical: item.logical,
        //     group:[]
        //   };
        //   item.group.map(item2 => {
        //     let obj2={};
        //     if (item2.group.length == 0) {
        //       obj2 = {
        //         field:item2.field,
        //         operator: item2.operator,
        //         value:item2.value,
        //         logical: item2.logical
        //       };

        //     } else {
        //       obj2 = {
        //         logical: item2.logical,
        //         group:[]
        //       };
        //       item2.group.map(item3 => {
        //         const obj3 = {
        //           field:item3.field,
        //           operator: item3.operator,
        //           value:item3.value,
        //           logical: item3.logical
        //         };
        //         obj2.group.push(obj3);
        //       });
        //     }
        //     obj.group.push(obj2);
        //   });
        //   new_arr.push(obj);
        // }
      });
      this.form.condition = JSON.stringify(new_arr);
      if (new_arr.length == 1 && (!new_arr[0].value || !new_arr[0].logical || !new_arr[0].operator || !new_arr[0].field)) {
        this.form.condition = '';
      }
      const {
        totalNum,
        items
      } = await splitList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items.record;
      items.field.map(item => {
        let obj = item;
        obj.width = 150;
        if (item.ellipsis) {
          obj.customRender = text => h("a-tooltip", {
            "attrs": {
              "placement": "topLeft",
              "title": text
            }
          }, [text]);
        }
        return obj;
      });
      this.columns = items.field;
      this.pagination.total = totalNum;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};